var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"input",attrs:{"type":_vm.type,"id":_vm.id,"name":_vm.name,"placeholder":_vm.$t(_vm.placeholder),"autocomplete":"off","autofocus":_vm.setAutofocus},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }